import { useEffect, useState } from 'react';
import type { DecoratedMagicChat } from '@/features/magic/types';

export const useChat = (chat?: DecoratedMagicChat | null) => {
  const [statefulChat, setStatefulChat] = useState<DecoratedMagicChat | null>(
    chat ?? null
  );

  // Bootstrapped chats are provided via props
  useEffect(() => {
    setStatefulChat(chat ?? null);
  }, [chat]);

  return {
    chat: statefulChat,
    setChat: setStatefulChat,
  };
};
